export const workloadHpaFormSettings = [
  'basicBehavior',
  'metrics',
  'autoscalerBehavior',
] as const;

export type WorkloadHpaFormSettings = (typeof workloadHpaFormSettings)[number];
